import api from './api';

const settingsService = {
  // Company Settings
  getCompanySettings: () => api.get('/companysettings'),
  getCompanySettingsFlat: () => api.get('/companysettings/flat'),
  getCompanyName: () => api.get('/companysettings/company-name'),
  saveCompanySettings: (settings: { key: string; value: string; category: string }[]) =>
    api.post('/companysettings/bulk', settings),

  // Currencies
  getCurrencies: (includeInactive = false) => api.get(`/currencies?includeInactive=${includeInactive}`),
  getCurrency: (id: number) => api.get(`/currencies/${id}`),
  getDefaultCurrency: () => api.get('/currencies/default'),
  createCurrency: (data: any) => api.post('/currencies', data),
  updateCurrency: (id: number, data: any) => api.put(`/currencies/${id}`, data),
  deleteCurrency: (id: number) => api.delete(`/currencies/${id}`),

  // Exchange Rates
  getExchangeRates: () => api.get('/exchangerates'),
  createExchangeRate: (data: any) => api.post('/exchangerates', data),
  deleteExchangeRate: (id: number) => api.delete(`/exchangerates/${id}`),
  convertCurrency: (from: string, to: string, amount: number) =>
    api.get(`/exchangerates/convert?from=${from}&to=${to}&amount=${amount}`),

  // Number Sequences
  getNumberSequences: () => api.get('/numbersequences'),
  getNumberSequence: (id: number) => api.get(`/numbersequences/${id}`),
  createNumberSequence: (data: any) => api.post('/numbersequences', data),
  updateNumberSequence: (id: number, data: any) => api.put(`/numbersequences/${id}`, data),
  deleteNumberSequence: (id: number) => api.delete(`/numbersequences/${id}`),
  previewNumberSequence: (type: string) => api.get(`/numbersequences/preview/${type}`),
};

export default settingsService;
